module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Light.ddae281a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Light.woff
// module id = 513
// module chunks = 0